import { render, staticRenderFns } from "./IconFilledWarning.vue?vue&type=template&id=a5a751c6&"
import script from "./IconFilledWarning.vue?vue&type=script&lang=ts&"
export * from "./IconFilledWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports